/**
 * 通用搜索模块
 */
import request from '@/utils/request';
// 列表
export function seachermodelsQuery(option) {
  return request({
    url: `/seachermodels/page-list`,
    method: 'get',
    params: option
  });
}
// 详情
export function seachermodelsDetail(id) {
  return request({
    url: `/seachermodels/${id}`,
    method: 'get'
  });
}
// 添加
export function seachermodelsAdd(option) {
  return request({
    url: `/seachermodels/`,
    method: 'POST',
    data: option
  });
}
// 编辑
export function seachermodelsEdit(id, option) {
  return request({
    url: `/seachermodels/${id}`,
    method: 'PUT',
    data: option
  });
}
// 删除
export function seachermodelsDel(id) {
  return request({
    url: `/seachermodels/${id}`,
    method: 'DELETE'
  });
}
